<template>
  <CCard>
    <CCardHeader>
      <CRow>
      </CRow>
      <!--        </div>-->

      <!-- Right aligned nav items -->
      <!--      </CCollapse>-->
    </CCardHeader>
    <CCardBody>

      <BTabs>

        <BTab   v-if="has_permission('Cashiers') " :title="$t('cashBalance')">
          <Cashiers/>
        </BTab>
        <BTab  v-if="has_permission('Banks')" :title="$t('sidebars.banks')">
          <Banks/>
        </BTab>

        <BTab  v-if="has_permission('Banks')" :title="$t('ChequeBooks')">
          <ChqueBooks/>
        </BTab>
        <BTab  v-if="has_permission('Cashiers')" :title="$t('sidebars.terminals')">
          <Terminals/>
        </BTab>


      </BTabs>

    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import AccountingGroupsLists2 from "./AccountingGroupsLists2";
import AccountingGroupsTree from "./AccountingGroupsTree";
import Vat from "../settings/Vat";
import Cashiers from "./Cashiers";
import Banks from "./Banks";
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import BTabs from "../../tabs/BTabs";
import ChqueBooks from "./ChqueBooks";
import Terminals from "./Terminals";
import BTab from "../../tabs/BTab";
export default {
  name: 'Login',
  components: {
    BTab,
    BTabs,
    ChqueBooks,
    Cashiers,
    Banks,
    Terminals,
  },
  data() {
    return {

    }
  }, mounted() {

  }, watch: {

  },
  methods: {


  }
}

</script>
